import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Result } from "antd";
const UnAuthorisedPage = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { errorCode, errorDescription, errorTitle } = state || "";
  console.log(state);
  return (
    <>
      <Result
        status={errorCode ? errorCode : "warning"}
        title={errorTitle ? errorTitle : t("LANDING.NOTFOUND_DEFAULT_TITLE")}
        subTitle={
          errorDescription ? errorDescription : t("LANDING.NOTFOUND_DEFAULT")
        }
      />
    </>
  );
};
export default UnAuthorisedPage;
